module.exports = __webpack_public_path__ + "Milestone.0ea62ea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/Milestone.png
// module id = 1513
// module chunks = 0